import React, { Component, createRef } from "react";
import { DateRangePicker } from "react-date-range";
import { format, addDays, differenceInDays } from "date-fns";
import { enUS } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

class AppDateRangePicker extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    const startDate = props.defaultStartDate || today;
    const endDate = props.defaultEndDate || today;
    this.state = {
      showPicker: false,
      selectionRange: {
        startDate: startDate,
        endDate: endDate,
        key: "selection",
      },
      restrictRange: false,
    };
    this.wrapperRef = createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(event.target)
    ) {
      this.setState({ showPicker: false });
      //   this.clearRange();
    }
  };

  handleSelect = (ranges) => {
    const { selection } = ranges;
    const { autoEndOffsetDays, maxSelectableDays } = this.props;

    let { startDate, endDate } = selection;

    const isSingleDaySelection =
      startDate &&
      (!endDate || startDate.toDateString() === endDate.toDateString());

    if (isSingleDaySelection && autoEndOffsetDays) {
      endDate = addDays(startDate, autoEndOffsetDays);
    }

    if (maxSelectableDays && startDate && endDate) {
      const diff = differenceInDays(endDate, startDate);
      if (diff > maxSelectableDays) {
        endDate = addDays(startDate, maxSelectableDays);
      }
    }

    const newRange = { ...selection, endDate };

    const isFinalSelection =
      startDate && endDate && startDate.getTime() !== endDate.getTime();

    this.setState({
      selectionRange: newRange,
      restrictRange: true,
      showPicker: isFinalSelection ? false : true,
    });

    if (this.props.onChange) {
      this.props.onChange(newRange);
    }
  };

  formatRange = () => {
    const { startDate, endDate } = this.state.selectionRange;
    return `${format(startDate, "MMM dd, yyyy")} - ${format(
      endDate,
      "MMM dd, yyyy"
    )}`;
  };

  togglePicker = () => {
    this.setState((prev) => ({ showPicker: !prev.showPicker }));
  };

  clearRange = () => {
    const today = new Date();
    const clearedRange = {
      startDate: today,
      endDate: today,
      key: "selection",
    };

    this.setState({
      selectionRange: clearedRange,
      restrictRange: false,
    });

    if (this.props.onChange) {
      this.props.onChange(null); // or pass clearedRange, depending on what you want
    }
  };

  render() {
    const { maxSelectableDays } = this.props;
    const { restrictRange } = this.state;

    return (
      <div className="app_datepicker_container" ref={this.wrapperRef}>
        <input
          type="text"
          readOnly
          onClick={this.togglePicker}
          value={this.formatRange()}
          className="date-input"
        />
        <button
          onClick={this.clearRange}
          className="clear-button"
          type="button"
        >
          <i class="fa fa-times"></i>
        </button>

        {this.state.showPicker && (
          <div className="calendar_container">
            <DateRangePicker
              locale={enUS}
              rangeColors={["#FBA106"]}
              color="#FBA106"
              className="App-DateRange"
              ranges={[this.state.selectionRange]}
              onChange={this.handleSelect}
              staticRanges={[]} // hide sidebar
              inputRanges={[]} // hide quick input range
              minDate={undefined}
              maxDate={
                restrictRange && maxSelectableDays
                  ? addDays(
                      this.state.selectionRange.startDate,
                      maxSelectableDays
                    )
                  : undefined
              }
            />
          </div>
        )}
      </div>
    );
  }
}

export default AppDateRangePicker;
